import { useRef, useState } from 'react';
import ModalWrapper from '../../components/modals/ModalWrapper';
import ModalHeader from '../../components/modals/ModalHeader';
import { IonButton, IonContent } from '@ionic/react';
import SignupForm, { SignupFormHandle } from '../sign-up/SignupForm';
import { useSelector } from 'react-redux';
import { StoreInterface } from '../../../../store/types';
import { SignupSchema } from '../sign-up/schema';
import { useUpdateProfileMutation } from '../../../../store/api-slices';
import { IModal } from '../../router/ModalRouter';
import { useTranslation } from 'react-i18next';

const ManageAccountModal = ({ goBack, closeModal }: Partial<IModal>) => {
  const { t } = useTranslation(null, {
    keyPrefix: 'Modules:Mobile:Features:Profile:Components:ProfileModal:NestedModals:ManageAccountModal',
  });
  const formRef = useRef<SignupFormHandle>(null);
  const profile = useSelector((state: StoreInterface) => state.profile.profile);
  const [updateProfile] = useUpdateProfileMutation();
  const [loading, setLoading] = useState<boolean>(false);

  const onSubmit = (data: SignupSchema): void => {
    const { company_id, phone_number: _, ...rest } = data;
    setLoading(true);
    updateProfile({
      companyId: company_id,
      data: rest,
    })
      .then(() => closeModal())
      .finally(() => setLoading(false));
  };
  const onDelete = (): void => {
    alert('TODO');
  };

  // TODO: add translations + BE
  return (
    <>
      <ModalWrapper className="mt-4">
        <ModalHeader
          title={t('title')}
          onBack={() => goBack()}
          endText={t('buttons.save')}
          loading={loading}
          onEndClick={() => formRef.current.submit()}
        />
        <IonContent className="min-h-[75dvh] [&::part(scroll)]:py-4 space-y-md">
          <SignupForm ref={formRef} defaultValues={profile} onSubmit={onSubmit} />
          <IonButton className="mx-auto px-md" expand="full" fill="clear" color="danger" onClick={onDelete}>
            {t('buttons.delete')}
          </IonButton>
        </IonContent>
      </ModalWrapper>
    </>
  );
};

export default ManageAccountModal;
